import { Box, Grid, Typography } from "@mui/material";

export const DisplayRow = ({ label, value }: { label: React.ReactNode, value: React.ReactNode }) => (
    <Grid
        container
        spacing={1.5}
        alignItems="stretch"
        sx={{
            py: 0.75,
            borderBottom: (t) => `1px dashed ${t.palette.divider}`,
            "&:last-of-type": { borderBottom: "none" },
        }}
    >
        <Grid item xs={12} sm={4}>
            <Box
                sx={(t) => ({
                    bgcolor: t.palette.grey[100],
                    border: `1px solid ${t.palette.grey[200]}`,
                    borderRadius: 1,
                    px: 1,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                })}
            >
                {typeof label === "string" ? (
                    <Typography variant="body2" fontWeight={600} color="text.secondary">{label}</Typography>
                ) : (
                    label
                )}
            </Box>
        </Grid>

        <Grid item xs={12} sm={8}>
            <Box
                sx={(t) => ({
                    border: `1px solid ${t.palette.grey[200]}`,
                    bgcolor: t.palette.grey[50],
                    borderRadius: 1,
                    px: 1.25,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                })}
            >
                <Typography variant="body1" fontWeight={600}>
                    {value || "—"}
                </Typography>
            </Box>
        </Grid>
    </Grid>
)
